import { useState } from 'react';

function useOptimizePost() {
    const [isLoadingOptimization, setIsLoadingOptimization] = useState(false);
    const [optimizationMessages, setOptimizationMessages] = useState([]);

    const optimizePost = async (type, text, playBellSound) => {
        try {

            const clearHtmlFromText = (text) => {
                if (Array.isArray(text)) {
                    text = text.join(" ");  // Convert array to string by joining with a space
                }
                if (typeof text !== "string") {
                    console.error("clearHtmlFromText received non-string input:", text);
                    return "";
                }
                const regex = /(<([^>]+)>)/gi;
                return text.replace(regex, "");
            };


            const actionType = type.toLowerCase().replace(/_/g, ' ').replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
            setOptimizationMessages(prevMessages => {
                const updated = [...prevMessages, { message: actionType, type: "userMessage" }];
                return updated.slice(-6); // keep only last 6
            });
            setIsLoadingOptimization(true);

            const response = await fetch('/api/posts/optimize', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ message: clearHtmlFromText(text), type: type }),
            });

            if (response.body) {
                const reader = response.body.getReader();
                const decoder = new TextDecoder();

                // Create an initial API message entry for the streamed response
                setOptimizationMessages(prevMessages => {
                    const updated = [...prevMessages, { message: "", type: "apiMessage" }];
                    return updated.slice(-6);
                });

                reader.read().then(function processText({ done, value }) {
                    if (done) {
                        setIsLoadingOptimization(false);
                        playBellSound();
                        return;
                    }

                    // Decode the chunk and append it to the API message
                    const chunk = decoder.decode(value, { stream: true });

                    // Append chunk to the latest apiMessage
                    setOptimizationMessages(prevMessages => {
                        const newMessages = [...prevMessages];
                        const apiMessageIndex = newMessages.findIndex(
                            (msg, index) => msg.type === "apiMessage" && index >= newMessages.length - 1
                        );
                        if (apiMessageIndex !== -1) {
                            newMessages[apiMessageIndex].message += chunk;
                        }
                        return newMessages.slice(-6); // still enforce limit
                    });

                    // Read the next chunk
                    reader.read().then(processText);
                });
            }
        } catch (error) {
            console.error("Error generating summaries:", error);
        }
    }

    return { isLoadingOptimization, optimizationMessages, setOptimizationMessages, optimizePost };
}

export default useOptimizePost;
